import type { OrderDetailToPrint } from './orderToPrint.model';

export function checkIfHasOrderToPrint(order: OrderDetailToPrint) {
  return Boolean(order.id);
}

export function calcTotalUnitsOfOrder(prods: OrderDetailToPrint['products']) {
  return prods.reduce((acc, product) => acc + product.units, 0);
}
